import { useSetAtom } from "jotai";
import { demoToastState, Toast } from "@/features/demo/model/demoToast.atom";

export const useDemoToast = () => {
  const setToasts = useSetAtom(demoToastState);

  const removeToast = (id: string) => {
    setToasts((prev) => prev.filter((toast) => toast.id !== id));
  };

  const showToast = (message: string) => {
    const id = Math.random().toString();
    const newToast: Toast = { id, message };

    setToasts((prev) => [...prev, newToast]);

    setTimeout(() => {
      removeToast(id);
    }, 3000);
  };

  return { showToast, removeToast };
};
